<template>
  <div>
    <!-- 헤더 / web	-->
    <div id="head">
      <h1 class="logo">
        <router-link to="/">페럼인프라</router-link>
      </h1>
      <!-- <button class="btn_ENG">ENG</button> -->

      <!--     -->
      <!-- gnb + active 시 메뉴 슬라이드 열림 -->
      <!-- gnb + active + off 시 메뉴 슬라이드 닫힘 -->

      <!--	메뉴	-->
      <div id="gnb_area">
        <ul class="gnb" :class="{ active: cssGnb, off: offCss }" @mouseover="showCssGnb(true)">
          <li>
            <a>회사소개</a>
            <div class="gnb_list first">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/Company/CEO">CEO</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Company/Principle">DK WAY</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Company/History">연혁</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Company/Network">네트워크</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Company/CI">CI</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Company/Ethics">윤리경영</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a>사업소개</a>
            <div class="gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/Biz/Club">페럼클럽</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Biz/MRO">MRO</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Biz/Tower">페럼홀</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a title="8월 1일 오픈 예정입니다.">홍보센터</a>
            <div class="gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/Public/News">뉴스룸</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Public/PRVideo">홍보영상</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a title>인재경영</a>
            <div class="gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/Management/Talent">인재상</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Management/Personnel">인사제도</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/Management/Recruitment">인재채용</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a title>투자정보</a>
            <div class="gnb_list">
              <ul title>
                <li @click="cssGnb = false">
                  <router-link to="/Invest/finance">재무정보</router-link>
                </li>
                <!-- 공고 삭제  장근주 대리 요청 2020-07-31 -->
                <li @click="cssGnb = false">
                  <router-link to="/Invest/NotiList">공고</router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="gnb_bg" @mouseover="showCssGnb(false)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Header.vue",
    cssGnb: false,
    offCss: false,
    mBtnMenu: false,
    isMobile: false,
    mSub01: false,
    mSub02: false,
    mSub03: false,
    windowWidth: 0,
    windowHeight: 0,
  }),
  methods: {
    showCssGnb(bShow) {
      console.log(
        "showCssGnb - bShow = " +
          bShow +
          ", this.bHeaderShowDelay = " +
          this.bHeaderShowDelay
      );

      if (bShow) {
        this.offCss = false;
        this.cssGnb = true;
      }

      if (bShow == false) {
        this.bHeaderShowDelay = true;
        this.offCss = true;
        // this.cssGnb = false;
      }
    },
    btnMobileSubMenu(btnIndex) {
      switch (btnIndex) {
        case "mSub01":
          {
            this.mSub01 = !this.mSub01;
            this.mSub02 = false;
            this.mSub03 = false;
          }
          break;
        case "mSub02":
          {
            this.mSub01 = false;
            this.mSub02 = !this.mSub02;
            this.mSub03 = false;
          }
          break;
        case "mSub03":
          {
            this.mSub01 = false;
            this.mSub02 = false;
            this.mSub03 = !this.mSub03;
          }
          break;
      }
    },
  },
  computed: {
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    },
  },
  mounted() {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
    // this.bHeaderShowDelay = true;
    // setTimeout(() => {
    //   this.bHeaderShowDelay = false;
    // }, 500);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue